import {
    UNDO_COMMAND,
    REDO_COMMAND,
    FORMAT_TEXT_COMMAND,
    TextFormatType,
    LexicalEditor
} from "lexical";

export function Undo(editor: LexicalEditor) {
    if (editor != null)
        editor.dispatchCommand(UNDO_COMMAND, undefined);
}

export function Redo(editor: LexicalEditor) {
    if (editor != null)
        editor.dispatchCommand(REDO_COMMAND, undefined);
}

export function FormatText(editor: LexicalEditor, format: string) {
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, format as TextFormatType);
}
